declare namespace $ {

	type $mol_locale_select__dictionary_bog_merchquarium_settings_1 = $mol_type_enforce<
		({ 
			'ru': string,
			'en': string,
		}) 
		,
		ReturnType< $mol_locale_select['dictionary'] >
	>
	type $mol_paragraph__title_bog_merchquarium_settings_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_settings_3 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['account_lord'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_merchquarium_settings_4 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['account_id'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_section__title_bog_merchquarium_settings_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_string__hint_bog_merchquarium_settings_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_merchquarium_settings_8 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['catalog_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_bog_merchquarium_settings_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_settings_10 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['theme_options'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_bog_merchquarium_settings_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_merchquarium_settings_12 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['listed'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_section__title_bog_merchquarium_settings_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_string__hint_bog_merchquarium_settings_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_merchquarium_settings_16 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['social_link'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_merchquarium_settings_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_merchquarium_settings_18 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['social_text'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_paragraph__title_bog_merchquarium_settings_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $bog_merchquarium_tags__items_bog_merchquarium_settings_20 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['link_items'] >
		,
		ReturnType< $bog_merchquarium_tags['items'] >
	>
	type $bog_merchquarium_tags__editable_bog_merchquarium_settings_21 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['is_admin'] >
		,
		ReturnType< $bog_merchquarium_tags['editable'] >
	>
	type $bog_merchquarium_tags__input_hint_bog_merchquarium_settings_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_tags['input_hint'] >
	>
	type $bog_merchquarium_tags__item_add_bog_merchquarium_settings_23 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['link_add'] >
		,
		ReturnType< $bog_merchquarium_tags['item_add'] >
	>
	type $bog_merchquarium_tags__item_drop_bog_merchquarium_settings_24 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['link_drop'] >
		,
		ReturnType< $bog_merchquarium_tags['item_drop'] >
	>
	type $mol_section__title_bog_merchquarium_settings_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $bog_merchquarium_tags__items_bog_merchquarium_settings_27 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['category_items'] >
		,
		ReturnType< $bog_merchquarium_tags['items'] >
	>
	type $bog_merchquarium_tags__editable_bog_merchquarium_settings_28 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['is_admin'] >
		,
		ReturnType< $bog_merchquarium_tags['editable'] >
	>
	type $bog_merchquarium_tags__input_hint_bog_merchquarium_settings_29 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_tags['input_hint'] >
	>
	type $bog_merchquarium_tags__confirm_title_bog_merchquarium_settings_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_tags['confirm_title'] >
	>
	type $bog_merchquarium_tags__usage_bog_merchquarium_settings_31 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['category_usage'] >
		,
		ReturnType< $bog_merchquarium_tags['usage'] >
	>
	type $bog_merchquarium_tags__item_add_bog_merchquarium_settings_32 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['category_add'] >
		,
		ReturnType< $bog_merchquarium_tags['item_add'] >
	>
	type $bog_merchquarium_tags__item_drop_bog_merchquarium_settings_33 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['category_drop'] >
		,
		ReturnType< $bog_merchquarium_tags['item_drop'] >
	>
	type $mol_section__title_bog_merchquarium_settings_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $bog_merchquarium_tags__items_bog_merchquarium_settings_36 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['fandom_items'] >
		,
		ReturnType< $bog_merchquarium_tags['items'] >
	>
	type $bog_merchquarium_tags__editable_bog_merchquarium_settings_37 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['is_admin'] >
		,
		ReturnType< $bog_merchquarium_tags['editable'] >
	>
	type $bog_merchquarium_tags__input_hint_bog_merchquarium_settings_38 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_tags['input_hint'] >
	>
	type $bog_merchquarium_tags__marker_bog_merchquarium_settings_39 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_tags['marker'] >
	>
	type $bog_merchquarium_tags__confirm_title_bog_merchquarium_settings_40 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_tags['confirm_title'] >
	>
	type $bog_merchquarium_tags__usage_bog_merchquarium_settings_41 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['fandom_usage'] >
		,
		ReturnType< $bog_merchquarium_tags['usage'] >
	>
	type $bog_merchquarium_tags__item_add_bog_merchquarium_settings_42 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['fandom_add'] >
		,
		ReturnType< $bog_merchquarium_tags['item_add'] >
	>
	type $bog_merchquarium_tags__item_drop_bog_merchquarium_settings_43 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['fandom_drop'] >
		,
		ReturnType< $bog_merchquarium_tags['item_drop'] >
	>
	type $mol_section__title_bog_merchquarium_settings_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_paragraph__title_bog_merchquarium_settings_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_bog_merchquarium_settings_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_bog_merchquarium_settings_48 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['import_prompt'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_textarea__hint_bog_merchquarium_settings_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_merchquarium_settings_50 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['import_json'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_paragraph__title_bog_merchquarium_settings_51 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['import_preview'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_bog_merchquarium_settings_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_settings_53 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['import_run'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_bog_merchquarium_settings_54 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['import_ready'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_section__title_bog_merchquarium_settings_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_paragraph__title_bog_merchquarium_settings_57 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['debug_info'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $giper_baza_land_rights__land_bog_merchquarium_settings_58 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['catalog_land'] >
		,
		ReturnType< $giper_baza_land_rights['land'] >
	>
	type $mol_section__title_bog_merchquarium_settings_59 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_merchquarium_settings_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_view__style_bog_merchquarium_settings_61 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['image_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_button_open__files_bog_merchquarium_settings_62 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['image_add'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_button_open__multiple_bog_merchquarium_settings_63 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open['multiple'] >
	>
	type $mol_button_open__accept_bog_merchquarium_settings_64 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_open__sub_bog_merchquarium_settings_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	type $mol_button_minor__hint_bog_merchquarium_settings_66 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_merchquarium_settings_67 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['image_filled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_merchquarium_settings_68 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['image_drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_settings_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_settings_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_merchquarium_settings_71 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['theme_swatch'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_merchquarium_settings_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_settings_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_merchquarium_settings_74 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_settings['theme_select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_settings_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_merchquarium_settings extends $mol_page {
		Lang( ): $mol_locale_select
		Sync( ): $giper_baza_status
		Account_label( ): $mol_paragraph
		account_lord( ): string
		Account_lord( ): $mol_paragraph
		account_id( ): string
		Account_id( ): $mol_button_copy
		Account_section( ): $mol_section
		catalog_title( next?: string ): string
		Catalog_title( ): $mol_string
		Images( ): $mol_view
		theme_options( ): readonly(any)[]
		Themes( ): $mol_view
		listed( next?: boolean ): boolean
		Listed( ): $mol_check_box
		Look_section( ): $mol_section
		social_link( next?: string ): string
		Social_link( ): $mol_string
		social_text( next?: string ): string
		Social_text( ): $mol_string
		Links_label( ): $mol_paragraph
		link_items( ): readonly(string)[]
		is_admin( ): boolean
		link_add( id: any, next?: any ): any
		link_drop( id: any, next?: any ): any
		Links( ): $bog_merchquarium_tags
		Sales_section( ): $mol_section
		category_items( ): readonly(string)[]
		category_usage( id: any): number
		category_add( id: any, next?: any ): any
		category_drop( id: any, next?: any ): any
		Categories( ): $bog_merchquarium_tags
		Categories_section( ): $mol_section
		fandom_items( ): readonly(string)[]
		fandom_usage( id: any): number
		fandom_add( id: any, next?: any ): any
		fandom_drop( id: any, next?: any ): any
		Fandoms( ): $bog_merchquarium_tags
		Fandoms_section( ): $mol_section
		Import_hint( ): $mol_paragraph
		import_prompt( ): string
		Import_prompt( ): $mol_button_copy
		import_json( next?: string ): string
		Import_json( ): $mol_textarea
		import_preview( ): string
		Import_preview( ): $mol_paragraph
		import_run( next?: any ): any
		import_ready( ): boolean
		Import_run( ): $mol_button_major
		Import_section( ): $mol_section
		debug_info( ): string
		Debug_info( ): $mol_paragraph
		catalog_land( ): any
		Rights( ): $giper_baza_land_rights
		Access_section( ): $mol_section
		image_style( id: any): Record<string, any>
		Image_preview( id: any): $mol_view
		image_add( id: any, next?: readonly(File)[] ): readonly(File)[]
		image_title( id: any): string
		Image_pick( id: any): $mol_button_open
		image_filled( id: any): boolean
		image_drop( id: any, next?: any ): any
		Image_drop_icon( id: any): $mol_icon_close
		Image_drop( id: any): $mol_button_minor
		Image_actions( id: any): $mol_view
		theme_select( id: any, next?: any ): any
		theme_swatch( id: any): Record<string, any>
		Theme_swatch( id: any): $mol_view
		theme_name( id: any): string
		Theme_name( id: any): $mol_view
		title( ): string
		Import_summary( ): string
		Import_errors( ): string
		Theme_sakura( ): string
		Theme_lavender( ): string
		Theme_mint( ): string
		Theme_peach( ): string
		Theme_sky( ): string
		Theme_milk( ): string
		Theme_classic( ): string
		catalog_link( next?: string ): string
		head( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Image_field( id: any): $mol_view
		Image_avatar( ): string
		Image_cover( ): string
		Image_back( ): string
		Theme_option( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map